export default {"src":"/_next/static/media/testimonial-icon.f19faf56.svg","height":68,"width":68,"blurWidth":0,"blurHeight":0};